export default __webpack_public_path__ + "static/media/filledGreenTick.8f83a6c0.svg";